import React from 'react';
import { Dialog as DialogComponent } from '@mui/material';
import styled from '@emotion/styled';

const Frame = styled.div({
    padding: '10pt',
    border: 'thin solid #ccc',
    backgroundColor: ' #fff',
    borderRadius: '5pt',
    opacity: 1.0,
});

export type DialogProps = React.PropsWithChildren<{
    className?: string;
    onClose?: () => void;
}>

export const Dialog = (props: DialogProps) => {
    return (
        <DialogComponent sx={{ color: theme => theme.typography.body1.color }} open={true} onClose={props.onClose} maxWidth={'md'} >
            <Frame>
                {props.children}
            </Frame>
        </DialogComponent>
    );
};
